import { FormikTouched } from "formik"

export function checkTouched(touched: FormikTouched<any>, fieldName: string) {
  if (!touched[fieldName]) {
    touched[fieldName] = true
  }
}

export function someAreTouched(touched: FormikTouched<any>): boolean {
  return touched !== undefined && JSON.stringify(touched) !== "{}"
}

export function isTouched(touched: FormikTouched<any>, fieldName: string): boolean {
  if (!someAreTouched(touched)) {
    return false
  }
  return touched[fieldName] === true
}
